<template>
    <div>
        <nav id="nav-menu" class="fixed-bottom py-0 d-flex justify-content-around mt-2">
      <div :style="mtdGetStyle('control')" class="navbar-brand pl-2 text-white text-center pr-2 nav-footer w-100 border-end border-white border" @click="mtdSendOption('control')"><span :style="mtdGetStyleSpan('control')" class="btn w-100"><strong>CONTROL DIARIO</strong></span></div>
      <div :style="mtdGetStyle('tramas')" class="navbar-brand pl-2 text-white text-center pr-2 nav-footer w-100 border-end border-white border" @click="mtdSendOption('tramas')"><span :style="mtdGetStyleSpan('tramas')" class="btn w-100"><strong>TRAMAS</strong></span></div>
      
    </nav>
    </div>
</template>
<script>
export default {
  name: 'FooterRecursosHumanosComponent',
  props: {
    pageView: String
  },
  data () {
    return {
      page: null
    }
  },
  created () {
   
  },
  methods: {
    mtdGetStyle:function(option){
      if (option == this.page && this.pageView != "home") return 'background: #900052';
      return '';
    },
    mtdGetStyleSpan:function(option){
      if (option == this.page && this.pageView != "home") return 'color:white';
      return '';
    },
    mtdSendOption: function(page){
      this.page=page;
      this.$emit('mtdChangePage',this.page)
    }
  },
}
</script>